import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  name: 'Intro',
  id: 'intro'
}, {
  name: 'Architecture',
  id: 'architecture'
}, {
  name: 'Technology',
  id: 'technology'
}, {
  name: 'AI-SEO',
  id: 'ai-seo'
}, {
  name: 'Ads',
  id: 'ads'
}, {
  name: 'Delegate',
  id: 'delegate'
}, {
  name: 'Clients',
  id: 'clients'
}, {
  name: 'Process',
  id: 'process'
}, {
  name: 'Pricing',
  id: 'pricing'
}];
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('intro');
  useEffect(() => {
    const handleScroll = () => {
      const sections = navLinks.map(link => document.getElementById(link.id));
      const scrollPosition = window.scrollY + 100;
      for (const section of sections) {
        if (section && section.offsetTop <= scrollPosition && section.offsetTop + section.offsetHeight > scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <nav className="fixed top-0 left-0 right-0 z-50 h-[60px] bg-black/80 backdrop-blur-xl border-b border-white/10" data-id="element-15" data-mp="10ec1vfcm62xf">
        <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between" data-id="element-16" data-mp="1a5yoe7uejofh">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('intro')} data-id="element-17" data-mp="1f5bb8sl9wvi2">
            <img src="https://cdn.magicpatterns.com/uploads/67zHwkUGG57V28BfdhPHYH/LetLois_Logo_Wide_Lapels_Blue_Transparent_(2).png" alt="LetLois" className="h-7 w-auto" data-id="element-18" data-mp="1k4xov350kdre" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-19" data-mp="146bob07gw737">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className={`text-sm font-medium transition-colors duration-200 ${activeSection === link.id ? 'text-primary' : 'text-text-muted hover:text-white'}`} data-id="element-20" data-mp="zetnqd9cw8ir">
                {link.name}
              </button>)}
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-white" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-21" data-mp="1i6ml0jvgkfwa">
            {isOpen ? <X size={24} data-id="element-22" data-mp="3jx7srto6khzy" /> : <Menu size={24} data-id="element-23" data-mp="3jxpx7dkzy2iy" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-24" data-mp="1zfyka4fshcfg">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-black pt-[80px] px-6 lg:hidden" data-id="element-25" data-mp="1zh9o2498ik6k">
            <div className="flex flex-col space-y-6" data-id="element-26" data-mp="1gmun493d4hg3">
              {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className={`text-2xl font-bold text-left ${activeSection === link.id ? 'text-primary' : 'text-white'}`} data-id="element-27" data-mp="1kqsq4uvt6cef">
                  {link.name}
                </button>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}